import React, { ReactNode } from 'react';
import { Routes, Route } from 'react-router-dom';
import AdminDashboard from '../../admin/AdminDashboard';
import Adminmenu from '../../admin/adminmenu/AdminMenu';
import {AHeader} from '../../AHeader';
import './AdminLayout.css'
import AdminDonor from '../../admin/AdminDonor';
import AdminOrganiazation from '../../admin/AdminOrganiazation';
import AdminFundmanager from '../../admin/AdminFundmanager';
import AdminCountry from '../../admin/AdminCountry';
import AdminNeeds from '../../admin/AdminNeeds';
import AdminViewDonor from '../../admin/AdminViewDonor';
import AdminViewOrg from '../../admin/AdminViewOrg';
import AdminViewFund from '../../admin/AdminViewFund';
import {Footer} from '../../footer';

interface AdminLayoutProps {

  children?: ReactNode;
  // Define children as a ReactNode
}
const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {


  return (
    <div className="admin-layout-container">
      <AHeader/>
      <div >
        <Adminmenu />
        <div >
          <Routes>
            <Route path="/adashboard" element={<AdminDashboard />} />
            <Route path="/donor" element={<AdminDonor />} />
            <Route path="/org" element={<AdminOrganiazation />} />
            <Route path="/fundmanager" element={<AdminFundmanager />} />
            <Route path="/country" element={<AdminCountry />} />
            <Route path="/needs" element={<AdminNeeds />} />
            <Route path="/viewdonor/:donorID" element={<AdminViewDonor />} />
            <Route path="/vieworg/:orgID" element={<AdminViewOrg />} />
            <Route path="/viewfundmanager/:fundman_id" element={<AdminViewFund />} />
          </Routes>
        </div>
      </div>
      { children }
      <Footer />
    </div>
  );
};

export default AdminLayout;
